import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Completion from './pages/Completion';
import Confirm from './pages/Confirm';
import Consent from './pages/Consent';
import InquiryForm from './pages/Inquiry/index';

import urls, { inquiryUrl, confirmUrl, consentUrl, completionUrl } from './urls';

const InquiryRoutes = () => {
  return (
    <Switch>
      <Route exact path={inquiryUrl()} component={InquiryForm} />
      <Route exact path={confirmUrl()} component={Confirm} />
      <Route exact path={consentUrl()} component={Consent} />
      <Route exact path={completionUrl()} component={Completion} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default InquiryRoutes;
